import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HvSvg from 'src/components/HvSvg';
import { bindActionCreators } from 'redux';
import uiDux from 'src/redux/ui';

import {
  Title,
  ButtonGroup,
  CancelButton,
  SaveButton,
  SaveDescription,
  CloseModalIconContainer,
  Modal,
  ModalContent,
  WarningBar,
  WarningIconContainer,
  WarningUpArrow,
} from './styled';

export const mapStateToProps = ({ designPro }) => ({
  isSaveConfirmationModalOpen: designPro.ui.isSaveConfirmationModalOpen,
  jobDesigns: designPro.jobDesigns.jobDesigns,
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleCloseSaveConfirmationClick:
        uiDux.actions.handleCloseSaveConfirmationClick,
      handleCancelSaveConfirmationClick:
        uiDux.actions.handleCancelSaveConfirmationClick,
      handleConfirmSaveClick: uiDux.actions.handleConfirmSaveClick,
    },
    dispatch,
  );

export class SaveConfirmationModal extends PureComponent {
  static propTypes = {
    handleCancelSaveConfirmationClick: PropTypes.func.isRequired,
    handleCloseSaveConfirmationClick: PropTypes.func.isRequired,
    handleConfirmSaveClick: PropTypes.func.isRequired,
    isSaveConfirmationModalOpen: PropTypes.bool.isRequired,
    jobDesigns: PropTypes.object,
  };

  render() {
    const {
      handleCancelSaveConfirmationClick,
      handleCloseSaveConfirmationClick,
      handleConfirmSaveClick,
      isSaveConfirmationModalOpen,
      jobDesigns,
    } = this.props;

    if (!isSaveConfirmationModalOpen) return null;

    const isReplacingSavedDesign = jobDesigns.saved[0];

    return (
      <Modal isOpen={isSaveConfirmationModalOpen}>
        <ModalContent data-selenium="saveModel">
          <CloseModalIconContainer
            size={12}
            role="button"
            onClick={handleCloseSaveConfirmationClick}
          >
            <HvSvg src={require('src/assets/icons/x.svg')} disabled={false} />
          </CloseModalIconContainer>
          <Title>
            {isReplacingSavedDesign
              ? 'Replace Your Previously Saved Design'
              : 'Save Design'}
          </Title>
          <SaveDescription>
            {isReplacingSavedDesign
              ? 'You can only save one design at the moment. If you want to save a new design, you will have to override your previously saved design.'
              : 'Your design will be saved under the name "Saved Design"'}
          </SaveDescription>
          <ButtonGroup>
            <CancelButton
              onClick={handleCancelSaveConfirmationClick}
              data-selenium="cancelSaveButton"
            >
              Cancel
            </CancelButton>
            <SaveButton
              onClick={handleConfirmSaveClick}
              data-selenium="confirmSaveButton"
            >
              {isReplacingSavedDesign ? 'Replace Design' : 'Save Design'}
            </SaveButton>
          </ButtonGroup>
        </ModalContent>
        {isReplacingSavedDesign ? (
          <WarningBar>
            <WarningUpArrow />
            <WarningIconContainer size={14}>
              <HvSvg
                src={require('src/assets/icons/ic-warning.svg')}
                disabled={false}
              />
            </WarningIconContainer>
            Your previous design will no longer be accessible
          </WarningBar>
        ) : null}
      </Modal>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SaveConfirmationModal);
